import React from 'react';

/**
 * Agent settings overview page.
 */
export const Settings = () => {
  return (
    <div>
      <h2>Settings</h2>
    </div>
  );
};
